export default {
  name: "flag",
  props: {
    country: {
      type: String,
      required: true
    }
  }
};